export default "__VITE_ASSET__BAQpXiGU__"